export enum EnumEstadoLiquidacion {
  Pendiente = 1,
  Abierta,
  Cerrada,
  Anulada,
  Error
}
